import type { HumanoidAppearance } from '../GhostRenderer';
import { npc } from './npc';

/** Quiet branch-route residents. Their field tools are appearance props only;
 * the shared fitted figure supplies both world art and the dialogue bust. */
export const BRANCH_CAST: Record<string, HumanoidAppearance> = {
  glowspore_orla: npc({
    shape: 'round', color: '#d2b99f', eyes: 'round', mouth: 'smile', accessory: 'glasses',
    humanoid: {
      fit: true,
      hair: { style: 'bun', color: '#463f3b' },
      garment: { kind: 'apron', color: '#79b89e', underColor: '#354d53',
        trimColor: '#e0d5ad', pocketBottles: true },
      props: [{ kind: 'book', color: '#4b6162' }],
      art: { light: 'moonfall', role: 'scholar' },
    },
  }),
  moonfen_reedwarden: npc({
    shape: 'slim', color: '#b78f73', eyes: 'round', mouth: 'neutral',
    humanoid: {
      fit: true,
      hair: { style: 'loose', color: '#45493d', streakColor: '#afb2a0' },
      headgear: { kind: 'straw_hat', color: '#657b54', accentColor: '#c7b47c' },
      cloak: { color: '#3e594c', claspColor: '#c8b889' },
      garment: { kind: 'tunic', color: '#a09563', trimColor: '#cfcea7', beltColor: '#60503b' },
      // Plain crook and the map peeking from her bag read as fieldwork, with
      // no spearhead or combat equipment added to the shared prop vocabulary.
      props: [{ kind: 'satchel', color: '#775d3f', mapPeek: true }, { kind: 'cane', color: '#b09465' }],
      art: { light: 'overcast', role: 'warden' },
    },
  }),
  moonfen_beacon_keeper: npc({
    shape: 'wide', color: '#b59883', eyes: 'round', mouth: 'neutral',
    humanoid: {
      fit: true,
      hair: { style: 'thin', color: '#c6c5b8' },
      beard: { style: 'full', color: '#c6c5b8' },
      cloak: { color: '#4c4850', claspColor: '#c19a59' },
      garment: { kind: 'tunic', color: '#566b74', trimColor: '#b8a581', beltColor: '#665143' },
      props: [{ kind: 'lantern', glowColor: '#ffd080' }],
      art: { light: 'moon', role: 'keeper' },
    },
  }),
};
